import React, { useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import { Panel } from '../../../../../components/atoms/Panel';
import { RichTextEditor } from '../../../../../components/atoms/RichTextEditor';

export interface AddNotePanelProps {
  onAddNote?: (note: string, isInternal: boolean) => void;
}

export const AddNotePanel: React.FC<AddNotePanelProps> = ({ onAddNote }) => {
  const [value, setValue] = useState('');

  const handleSubmit = () => {
    const trimmed = value.replace(/<(.|\n)*?>/g, '').trim();
    if (!trimmed || !onAddNote) return;
    onAddNote(value, true);
    setValue('');
  };

  return (
    <Panel title="Add Note">
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box sx={{ '& .ql-editor': { minHeight: '160px' } }}>
          <RichTextEditor
            value={value}
            onValueChange={setValue}
          />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            size="small"
            variant="contained"
            onClick={handleSubmit}
            sx={{
              fontSize: '11px',
              textTransform: 'none',
              py: 0.75,
              px: 2.5,
              bgcolor: 'v4.accent',
              '&:hover': { bgcolor: 'v4.accent', opacity: 0.9 },
            }}
          >
            Add Note
          </Button>
        </Box>
      </Box>
    </Panel>
  );
};
